import axios from "axios";
import { baseUrl } from "../../shared/baseUrl";
import { 
  ADD_PROPERTY_REQUEST, 
  ADD_PROPERTY_SUCCESS, 
  ADD_PROPERTY_FAIL,
  GET_APPROVED_PROPERTY_REQUEST,
  GET_APPROVED_PROPERTY_SUCCESS,
  GET_APPROVED_PROPERTY_FAIL,
  GET_PROPERTY_ID_REQUEST,
	GET_PROPERTY_ID_SUCCESS,
	GET_PROPERTY_ID_FAIL } from "../constants/propertyConstants";

export const addPropertyAction = (
  title, 
  price, 
  state,
  lga,
  address,
  category,
  propertyType,
  bedrooms,
  bath,
  toilet,
  parkingSpace,
  square,
  furnished,
  serviced,
  shared,
  description,
	images
) => async (dispatch, getState) => {

	try {
		dispatch({
			type: ADD_PROPERTY_REQUEST
		})
    const { userLogin: { userInfo } } = getState()

		const config = {
			headers: {
				'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`
			}
		}
		const { data } = await axios.post(
			baseUrl + '/api/v1/properties', { 
        title,
        price, 
        state,
        lga,
        address,
        category,
        propertyType,
        bedrooms,
        bath,
        toilet,
        parkingSpace,
        square,
        furnished,
        serviced,
        shared,
        description,
				images
			}, config
		)

		dispatch({
			type: ADD_PROPERTY_SUCCESS,
			payload: data
		})
	}

	catch (error) {
		dispatch({
			type: ADD_PROPERTY_FAIL,
			payload: error.response && error.response.data.message
				? error.response.data.message
				: error.message
		})
	}
}


export const getApprovedPropertyAction = () => async (dispatch) => {
	try {
		dispatch({
			type: GET_APPROVED_PROPERTY_REQUEST
		})

		const config = {
			headers: {
				'Content-Type': 'application/json',
			}
		}

		const { data } = await axios.get(
			baseUrl + "/api/v1/properties/approved", config)

		dispatch({
			type: GET_APPROVED_PROPERTY_SUCCESS,
			payload: data
		})

	} 

  catch (error) {
		dispatch({
			type: GET_APPROVED_PROPERTY_FAIL,
			payload: error.response && error.response.data.message
				? error.response.data.message
				: error.message,
		})
	}
}


export const getPropertyIDAction = (id) => async (dispatch) => {
	try {
		dispatch({
			type: GET_PROPERTY_ID_REQUEST
		})

		const config = {
			headers: {
				'Content-Type': 'application/json',
			}
		}

		const { data } = await axios.get(
			baseUrl + `/api/v1/properties/${id}`, config)

		dispatch({
			type: GET_PROPERTY_ID_SUCCESS,
			payload: data
		})

	} 

  catch (error) {
		dispatch({
			type: GET_PROPERTY_ID_FAIL,
			payload: error.response && error.response.data.message
				? error.response.data.message
				: error.message,
		})
	}
}